import { Routes, RouterModule } from '@angular/router';
import { ProductProviderList } from './productproviderlist.list';
export const routes: Routes = [
    {
        path: 'productprovideredit/:id',
        data: { reuse: false },
        loadChildren: () =>
            import(
                '../providerproductdetail/providerproductdetail.module'
            ).then((mod) => mod.ProviderProductDetailModule),
    },
    { path: 'page/productproviderlist', component: ProductProviderList },
    { path: '', redirectTo: 'page/productproviderlist', pathMatch: 'full' },
];
export const PRODUCTPROVIDERLIST_ROUTER_PROVIDERS =
    RouterModule.forRoot(routes);
